<template>
	<Container>
		<TopBar/>
		<img class="certificate" :src="cerUrl">
		<div class="button-primary button" @click='download'><span>下載達人卡</span></div>
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				cerUrl:'',
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){
				let {cerUrl} = this.getParams()
				this.cerUrl = cerUrl
			},
			async download(){
				let name = this.$route.query?.code
				var link = document.createElement('a');
				//設置下載的文件名
				link.setAttribute("download", name);
				link.style.display = 'none';
				//設置下載路徑
				link.href = this.cerUrl;
				//觸發點擊
				document.body.appendChild(link);
				link.click();
				//移除節點
				document.body.removeChild(link);
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.certificate {
		margin: auto;
		display: block;
		max-width: 500px;
		margin-top: 20px;
	}
	.button {
		height:60px;
		width:20.83vw;
		min-width: 160px;
		border-radius: 60px;
		margin: 30px auto;
		@include fontSize($font-size-20);
	}
	@media (max-width: 768px){
		.certificate {
			max-width: 95%;
		}
	}
</style>